import request from './request'

export function listDictTypes() {
  return request.get('/sys/dicts/types')
}
export function listDicts(dictType) {
  return request.get('/sys/dicts', { params: { dictType } })
}
export function listDictOptions(dictType) {
  return request.get('/sys/dicts/options', { params: { dictType } })
}
export function saveDict(data) {
  return request.post('/sys/dicts', data)
}
export function deleteDict(id) {
  return request.delete(`/sys/dicts/${id}`)
}
